import * as React from "react";
import PropTypes from "prop-types";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";

function ValueLabelComponent(props) {
  const { children, value } = props;

  return (
    <Tooltip enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  value: PropTypes.number.isRequired,
};

const iOSBoxShadow =
  "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)";

const IOSSlider = styled(Slider)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? "#3880ff" : "#3880ff",
  height: 2,
  padding: "15px 0",
  "& .MuiSlider-thumb": {
    height: 20,
    width: 20,
    backgroundColor: "#fff",
    boxShadow: iOSBoxShadow,
    "&:focus, &:hover, &.Mui-active": {
      boxShadow:
        "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: iOSBoxShadow,
      },
    },
  },
  "& .MuiSlider-valueLabel": {
    fontSize: 12,
    fontWeight: "normal",
    top: -6,
    backgroundColor: "unset",
    color: theme.palette.text.primary,
    "&:before": {
      display: "none",
    },
    "& *": {
      background: "transparent",
      color: theme.palette.mode === "dark" ? "#fff" : "#000",
    },
  },
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-rail": {
    opacity: 0.5,
    backgroundColor: "#bfbfbf",
  },
  "& .MuiSlider-mark": {
    backgroundColor: "#bfbfbf",
    height: 8,
    width: 1,
    "&.MuiSlider-markActive": {
      opacity: 1,
      backgroundColor: "currentColor",
    },
  },
}));
let timer = null;

export default function CustomizedSlider(props) {
  const min = props.values.at(-1);
  const max = props.values[0];
  const [value, setValue] = React.useState([min, max]);

  function round(num, decimalPlaces) {
    num = Math.round(num + "e" + decimalPlaces);
    return Number(num + "e" + -decimalPlaces);
  }

  const markers = [
    {
      value: min,
      label: round(Number(min), 1),
    },
  ];
  if (min < 0) {
    markers.push({
      value: 0,
      // label: 0,
      label: "",
      // color: "#cccccc", //is not working
      // style: { color: "#cccccc" }, //is not working
    });
  }
  markers.push({
    value: max,
    label: round(Number(max), 1),
  });

  const pimps = document.querySelectorAll(".MuiSlider-valueLabelLabel");
  const handleChange = (event, newValue, activeThumb) => {
    if (timer) clearTimeout(timer);
    if (!Array.isArray(newValue)) {
      return;
    }

    for (let i = 0; i < newValue.length; i++) {
      const vl = round(Number(newValue[i]), 1);
      if (
        vl === 0 ||
        vl === round(Number(min), 1) ||
        vl === round(Number(max), 1)
      ) {
        pimps.forEach((el) => {
          if (el.innerHTML === vl) {
            el.classList.remove("labelVisible");
          }
        });
      } else {
        pimps.forEach((el) => {
          if (el.innerHTML === vl) {
            el.classList.add("labelVisible");
          }
        });
      }
    }

    if (newValue[1] - newValue[0] < min) {
      if (activeThumb === 0) {
        const clamped = Math.min(newValue[0], 100 - min);
        setValue([clamped, clamped + min]);
      } else {
        const clamped = Math.max(newValue[1], min);
        setValue([clamped - min, clamped]);
      }
    } else {
      setValue(newValue);
    }

    timer = setTimeout(() => {
      props.filter(value);
    }, 200);
  };

  function valueLabelFormat(value) {
    return round(Number(value), 1);
  }

  // console.log(markers);
  return (
    <Box sx={{ width: "85%", marginTop: "24px" }}>
      <IOSSlider
        // aria-label="ios slider"
        getAriaLabel={() => "ios slider"}
        value={value}
        onChange={handleChange}
        valueLabelDisplay="on"
        getAriaValueText={valueLabelFormat}
        valueLabelFormat={valueLabelFormat}
        disableSwap
        marks={markers}
        min={min}
        max={max}
      />
    </Box>
  );
}
